import { Agent, AgentAccessLevel } from "~/services/agents";

// Editing an agent is governed by the caller's `can_edit` grant: editors and
// owners hold it, a USER-level grant does not, and SYSTEM agents confer it on
// no one (null access_level → read-only for everyone). Derived from the caller's
// resolved access level, mirroring the backend role→permission matrix.
export const useCanEditAgent = (agent: Agent | undefined): boolean =>
  !!agent &&
  (agent.access_level === AgentAccessLevel.OWNER || agent.access_level === AgentAccessLevel.EDITOR);
